import { useColorMode, useColorStyle } from '@tonic-ui/react';

export const useThemeColorStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return colorStyle;
};
